import {API} from "@/Composables/api";

const getUsers = async (
    params: {
        include?: Array<string>;
        fields?: Array<string>;
    } = {},
) => {
    return API.get(route("admin.users.index"), params);
};

const getUser = async (user: string, params = {}) => {
    return API.get(route("admin.users.show", user), params);
};

const storeUser = async (user, params = {}) => {
    return API.post(route("admin.users.store"), params, user);
};

const inviteUser = async (formData, params = {}) => {
    return API.post(route("admin.users.invite"), params, formData);
};

const impersonateUser = async (userId: number, params = {}) => {
    return API.post(route("admin.users.impersonate", userId), params);
};

const updateUser = async (user, params = {}) => {
    return API.post(route("admin.users.update", [user.id]), params, user, "PUT");
};

const remindUserVerifyEmail = async (userId: number, params = {}) => {
    return API.post(route("admin.users.remind-verify-email", userId), params);
};

const verifyUserEmail = async (userId: number, params = {}) => {
    return API.put(route("admin.users.verify-email", userId), params);
};

const deleteUser = async (userId: number, params = {}) => {
    return API.delete(route("admin.users.destroy", userId), params);
};

const restoreUser = async (userId: number, params = {}) => {
    return API.post(route("admin.users.restore", userId), params);
};

const updateUserPlan = async (userId: string, planId: string, params = {}) => {
    return API.put(route("admin.users.plan.update", userId), params, {plan_id: planId});
};

export {
    getUsers,
    getUser,
    storeUser,
    inviteUser,
    impersonateUser,
    updateUser,
    remindUserVerifyEmail,
    verifyUserEmail,
    deleteUser,
    restoreUser,
    updateUserPlan,
};
